import { styled } from 'styled-components';

import { Section } from '../../index.ts';

export const Wrapper = styled(Section)`
  padding: 8px 0px;
`;
